<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
          <el-form-item label="修改时间:" class="item2">
            <el-date-picker
              style="width:420px"
              v-model="createTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结算客户:">
              <el-input placeholder="" v-model="searchFrom.payee" ></el-input>
            <!-- <el-select  v-model="searchFrom.payee" filterable allow-create placeholder="请选择" >
              <el-option  label="全部" value="" ></el-option>
              <el-option v-for="item in kehuList" :label="item.payee" :value="item.payee" :key="item.payee"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="运单编号:"  >
              <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNo" ></el-input>
          </el-form-item>
           <el-form-item label="签收时间:" >
            <el-date-picker
              v-model="actualSignings"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="承运商/部门:">
            <el-input placeholder="" v-model="searchFrom.generalCarrier" ></el-input>
            <!-- <el-select  v-model="searchFrom.generalCarrier" filterable placeholder="请选择">
              <el-option v-for="item in CYSList" :label="item.generalCarrier" :value="item.generalCarrier" :key="item.generalCarrier"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="子公司:">
            <el-input placeholder="" v-model="searchFrom.createSubcompanyName" ></el-input>
          <!-- <el-select v-model="searchFrom.createSubcompanyName" filterable clearable placeholder="请选择" @change="zigsChangeCX">
            <el-option v-for="item in zigongsiList" :label="item.companyName" :value="item.companyName" :key="item.id"></el-option>
          </el-select> -->
        </el-form-item>
       <el-form-item label="业务部门:" >
           <el-input placeholder="" v-model="searchFrom.businessSubunit" ></el-input>
          <!-- <el-select  v-model="searchFrom.businessSubunit" filterable placeholder="请选择" >
            <el-option  label="全部" value="" ></el-option>
            <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select> -->
        </el-form-item>
        </div>
        <div style="margin-left: 10px;">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun"> 查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
            <el-button type="primary" size="mini" :disabled="isDisable" @click="daochuFN">导出</el-button>
          </el-form-item>
          <el-form-item >
           <p class="margin0">差额合计:<span class="red">{{cehj}}</span>元</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tabref" @row-click="dianjixuanzhong" border height="100%" size="mini" class="tableComent" style="width:100%" @selection-change='selectGoods'>
        <!-- <el-table-column type="selection" width="50" fixed></el-table-column> -->
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
        <el-table-column prop="wayNo" label="运单编号" width="230" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="liquidatedAmount" label="结算量" width="80" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="modifyItem" label="修改项" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="beforeModification" label="修改前" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="beforeAmount" label="修改前总额(元)" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="afterModification" label="修改后" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="afterAmount" label="修改后总额(元)" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="difference" label="差额(元)" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="createUser" label="修改人" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="payee" label="结算客户" width="200" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="generalCarrier" label="承运商/部门" width="200" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="projectType" label="项目名称" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="createSubcompanyName" label="子公司" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="businessSubunit" label="业务部门" width="120" :show-overflow-tooltip="true" :formatter="formatterRowEmpty"> </el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="修改时间" width="170"></el-table-column>
        <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { findWayUpdateRecordList, findWayPayeeList, findGcDropDownBox, findWayUpdateRecordTotal } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import { getCurrUserDepartment, getCurrUserCompany } from '@/api/newCrm'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'Freight',
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      emptyFn: emptyFn,
      h: '500px',
      // 查询条件
      actualSignings: [],
      createTime: [],
      searchFrom: {
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      tableList: [],
      kehuList: [],
      CYSList: [],
      zigongsiList: [],
      bumenList: [],
      isDisable: false,
      cehj: ''
    }
  },
  created () {
    findWayPayeeList().then(res => { this.kehuList = res })
    findGcDropDownBox().then(res => {
      this.CYSList = res
    })
    getCurrUserCompany().then(res => { this.zigongsiList = res })
    this.createTime = getLastMonth()
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 166 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 子公司更改
    zigsChangeCX (e) {
      let json1 = this.zigongsiList.filter(item => item.companyName == e)
      getCurrUserDepartment({ compayCode: json1[0].companyCode }).then(res => { this.bumenList = res })
      this.$set(this.searchFrom, 'createSubdepartmentName', '')
    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.wayNo) {
        let wayNoStr = this.searchFrom.wayNo.trim()
        this.searchFrom.wayNos = wayNoStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.createTime) {
        this.searchFrom.createTimeStart = this.createTime[0]
        this.searchFrom.createTimeEnd = this.createTime[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.actualSignings) {
        this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
        this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
      } else {
        this.searchFrom.actualSigningTimeStart = ''
        this.searchFrom.actualSigningTimeEnd = ''
      }
      findWayUpdateRecordList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        findWayUpdateRecordTotal(this.searchFrom).then(res => {
          this.cehj = res
        })
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 选择数据
    selectGoods (selection) {
      // console.log(selection,'selection')
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      this.createTime = getLastMonth()
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 导出
    daochuFN () {
      if (this.searchFrom.wayNo) {
        let wayNoStr = this.searchFrom.wayNo.trim()
        this.searchFrom.wayNos = wayNoStr.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.createTime) {
        this.searchFrom.createTimeStart = this.createTime[0]
        this.searchFrom.createTimeEnd = this.createTime[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.actualSignings) {
        this.searchFrom.actualSigningTimeStart = this.actualSignings[0]
        this.searchFrom.actualSigningTimeEnd = this.actualSignings[1]
      } else {
        this.searchFrom.actualSigningTimeStart = ''
        this.searchFrom.actualSigningTimeEnd = ''
      }
      exportExcel(
        this.global.tmsPlus + '/updateRecord/exportWayUpdateRecord',
        this.searchFrom,
        '修改记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }

  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 290px);
  grid-auto-flow: row dense;
  .item1{
    grid-row-start: span 2;
  }
  .item2{
    grid-column-start: span 2;
    width: 540px;
  }
}
</style>
